// CEP-BUILD 2026-09-25-Z

class HeaderDrawer extends HTMLElement {
    constructor() {
        super();

        this.HeaderDrawer = this;
        this.HeaderDrawerToggle = this.querySelector('.header-drawer-toggle');
        this.HeaderDrawerDetails = this.querySelector('.header-drawer-details');
        this.subMenuItemIcons = this.querySelectorAll('.header-drawer-main-menu-item-icon');
        this.subMenuItemToggles = this.querySelectorAll('.header-drawer-main-menu-subitems-panel__title');
        // this.subMenuItemIcons = this.querySelectorAll('.header-drawer-main-menu-item-icon');
        // this.HeaderDrawerClose = this.querySelector('.cart-drawer-close');
        // this.HeaderDrawerOverlay = this.querySelector('.cart-drawer-overlay');

        this.HeaderDrawerToggle.addEventListener('click', (event) => this.onClick(event))

        document.addEventListener('click', (event) => {
            const btn = event.target.closest && event.target.closest('.cep-m-search');
            if (!btn) return;
            event.preventDefault();
            event.stopPropagation();
            if (!this.classList.contains('active')) this.open();
            const input = this.querySelector('.header-drawer-details input[type="search"]');
            if (input) {
                input.focus({ preventScroll: true });
                const dropdown = input.closest('search-dropdown');
                if (dropdown && typeof dropdown.open === 'function') dropdown.open();
            }
        }, true);

        const t = this.HeaderDrawerToggle;
        t.setAttribute('role', 'button');
        t.setAttribute('tabindex', '0');
        t.setAttribute('aria-label', 'Menu');
        t.setAttribute('aria-expanded', 'false');
        t.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') this.onClick(event);
        });
        // Escape closes; focus returns after keyup, since cart-drawer.js grabs focus on every Escape keyup.
        this.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && this.classList.contains('active')) { this.close(); this._restoreFocus = true; }
        });
        this.addEventListener('keyup', (event) => {
            if (event.key === 'Escape' && this._restoreFocus) { this._restoreFocus = false; setTimeout(() => t.focus(), 0); }
        });

        // this.HeaderDrawerClose.addEventListener('click', () => this.close())
        // this.HeaderDrawerOverlay.addEventListener('click', () => this.close())

        document.addEventListener('click', (event) => {
            const headerDrawer = this.HeaderDrawer;
            if (event.target !== headerDrawer && !headerDrawer.contains(event.target)) {
                this.close()
            }
        })

        for(let subMenuItemIcon of this.subMenuItemIcons ){
            subMenuItemIcon.addEventListener('click', () => this.subMenuClick(subMenuItemIcon))
        }

        this.subMenuLabelLinks = this.querySelectorAll('.header-drawer-main-menu-subitem.has-children > .header-drawer-main-menu-item-label a');
        for (let labelLink of this.subMenuLabelLinks) {
            labelLink.addEventListener('click', (event) => {
                event.preventDefault();
                const icon = labelLink.parentNode.querySelector('.header-drawer-main-menu-item-icon');
                if (icon) this.subMenuClick(icon);
            });
        }

        this.primaryLabels = this.querySelectorAll('.header-drawer-main-menu-item.has-children > .header-drawer-main-menu-item-label');
        for (let primaryLabel of this.primaryLabels) {
            primaryLabel.addEventListener('click', (event) => {
                // the chevron carries its own listener; let it handle itself
                if (event.target.closest('.header-drawer-main-menu-item-icon')) return;
                event.preventDefault();
                const icon = primaryLabel.querySelector('.header-drawer-main-menu-item-icon');
                if (icon) this.subMenuClick(icon);
            });
        }

        for(let subMenuItemToggle of this.subMenuItemToggles){
            subMenuItemToggle.addEventListener('click', () => this.subMenuToggleClick(subMenuItemToggle))
        }

        window.addEventListener('scroll', () => {
            // console.log("this", this);

            if(this.classList.contains('active')){
                var headerDrawerDetails = document.querySelector('.header-drawer-details');
                var headerDrawerAdditionalOffset = Math.ceil(headerDrawerDetails.getBoundingClientRect().top);
                this.style.setProperty('--header-drawer-details-additional-offset', headerDrawerAdditionalOffset + 'px');
            }
        })

    }

    onClick(event) {
        event.preventDefault();

        if( this.classList.contains('active') ){
            this.close();
        }
        else{
            this.open()
        }
    }

    open() {
        // this.HeaderDrawerDetails.style.display = 'flex';
        this.HeaderDrawerDetails.classList.add('visible');
        this.HeaderDrawerToggle.setAttribute('aria-expanded', 'true');

        setTimeout(() => {
            this.HeaderDrawer.classList.add('active')
        }, 50);
    }
    close() {
        this.HeaderDrawer.classList.remove('active')
        this.HeaderDrawerToggle.setAttribute('aria-expanded', 'false');

        setTimeout(() => {
            // this.HeaderDrawerDetails.style.display = 'none';
            this.HeaderDrawerDetails.classList.remove('visible');
        }, 300);
    }

    subMenuClick(subMenuItemIcon){

        const subMenuItem = subMenuItemIcon.parentNode.parentNode;

        this.HeaderDrawerDetails.classList.add('inactive');

        const willOpen = !subMenuItem.classList.contains('active');
        if (willOpen && subMenuItem.parentNode) {
            for (const sibling of subMenuItem.parentNode.children) {
                if (sibling !== subMenuItem) sibling.classList.remove('active');
            }
        }
        subMenuItem.classList.toggle('active');

        this.syncPanelHeight();
    }

    subMenuToggleClick(subMenuItemIcon){

        const subMenuItem = subMenuItemIcon.parentNode.parentNode;

        this.HeaderDrawerDetails.classList.remove('inactive');
        subMenuItem.classList.remove('active')

        this.syncPanelHeight();
    }

    syncPanelHeight(){
        const nav = this.querySelector('.header-drawer-main-menu');
        if (!nav) return;
        const activePanel = this.querySelector('.header-drawer-main-menu-item.active > .header-drawer-main-menu-subitems-panel');
        if (activePanel) {
            const h = activePanel.getBoundingClientRect().bottom - nav.getBoundingClientRect().top;
            nav.style.height = Math.max(0, Math.ceil(h)) + 'px';
        } else {
            nav.style.height = '';
        }
    }

}

customElements.define('header-drawer', HeaderDrawer);